import React from "react";
import { Box, Grid } from "@material-ui/core";

import { Layout, Section } from "../components";

function FitnessTrackerApp() {
  return (
    <Layout>
      <Box my={12}>
        <Section>
          <Box className="projectDetails">
            <Box className="banner">Fitness Tracker Mobile App</Box>
            <Box mt={4} className="title">
              Description
            </Box>
            <Box mt={2}>
              <Box my={1}>
                • Developed cross-platform MERNG mobile application on iOS and
                Android, designed user interface with Adobe Xd.
              </Box>
              <Box my={1}>
                • Developed a backend using Node.js and Express, implemented an
                access control system with JSON web token, storage and
                management of user’s profile, activity and meal data on MongoDB,
                and user data query and mutation service via GraphQL.
              </Box>
              <Box my={1}>
                • Developed a mobile application using React Native that
                consumes backend APIs to allows users to manage accounts, log
                activities and meals, and visualize daily and weekly progress
                with SVG Charts from d3.js.
              </Box>
            </Box>
            <Box mt={4} className="title">
              Tech Stacks
            </Box>
            <Box mt={1}>
              JavaScript (ES6), React Native, React Native Elements, React
              Native Papaer, React Navigation, React Native SVG Charts, React
              Native Vector Icons, Expo, Adobe Xd, VS Code, WebStrom
            </Box>

            <Box mt={4} className="title">
              Demo
            </Box>

            <Box mt={2}>
              <Grid container>
                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/0_sign_in.jpg"
                    alt="Sign In Screen"
                  />
                  <Box className="mobileDescription">Sign In Screen</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/1_sign_in.jpg"
                    alt="Sign Up Screen"
                  />
                  <Box className="mobileDescription">Sign Up Screen</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/2_home_daily.jpg"
                    alt="Home Screen - Daily Summary"
                  />
                  <Box className="mobileDescription">
                    Home Screen - Daily Summary
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/3_home_weekly_1.jpg"
                    alt="Home Screen - Weekly Carlories"
                  />
                  <Box className="mobileDescription">
                    Home Screen - Weekly Carlories
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/4_home_weekly_2.jpg"
                    alt="Home Screen - Weekly Nutritin"
                  />
                  <Box className="mobileDescription">
                    Home Screen - Weekly Nutrituion
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/5_meals_list.jpg"
                    alt="Meal Screen - Meal List"
                  />
                  <Box className="mobileDescription">
                    Meal Screen - Meal List
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/6_meals_create.jpg"
                    alt="Meal Screen - Create Meal"
                  />
                  <Box className="mobileDescription">
                    Meal Screen - Create Meal
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/7_meals_foods_list.jpg"
                    alt="Meal Modal - Edit Meal"
                  />
                  <Box className="mobileDescription">
                    Meal Modal - Edit Meal
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/8_meals_foods_edit.jpg"
                    alt="Food Modal - Edit Food"
                  />
                  <Box className="mobileDescription">
                    Food Modal - Edit Food
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/9_activities_list.jpg"
                    alt="Activity Screen - Activity List"
                  />
                  <Box className="mobileDescription">
                    Activity Screen - Activity List
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/10_activities_create.jpg"
                    alt="Activity Screen - Create Activity"
                  />
                  <Box className="mobileDescription">
                    Activity Screen - Create Activity
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/11_activities_edit.jpg"
                    alt="Activity Modal - Edit Activity"
                  />
                  <Box className="mobileDescription">
                    Activity Modal - Edit Activity
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/FitnessTracker/12_profile.jpg"
                    alt="Profile Screen"
                  />
                  <Box className="mobileDescription">Profile Screen</Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Section>
      </Box>
    </Layout>
  );
}

export default FitnessTrackerApp;
